module.exports = "<div id='container' class='container-fluid'>\n  <div class='row app-row'>\n    <div class='col-md-2 nav-sidebar'>\n      <app-nav></app-nav>\n    </div>\n\n    <div class='col-12 col-md-10 app-content'>\n      <router-outlet></router-outlet>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = 451
// module chunks = 0